enum BalancesViewType {
  DEPOSIT = 'DEPOSIT',
  CREDIT_CARD = 'CREDIT_CARD',
  CREDIT_CARD_RESTRICTED = 'CREDIT_CARD_RESTRICTED',
  BSU = 'BSU',
  EXTERNAL = 'EXTERNAL',
}

export default BalancesViewType;
